
import { Star, Rocket, MessageCircle, Bell } from "lucide-react";
import { getPropertyImageUrl, isPlaceholder, markAsPlaceholder, DEFAULT_IMAGE } from "@/lib/config/cdn";

interface ListingType {
  id: string;
  title: string;
  address: string;
  price: string;
  type: string;
  status: string;
  views: number;
  inquiries: number;
  image: string;
  featured: boolean;
  boosted: boolean;
  hasUnreadMessages?: boolean;
  hasUpdates?: boolean;
  listing_code?: string;
  listingCode?: string;
}

interface ListingImageProps {
  property: ListingType;
}

const ListingImage = ({ property }: ListingImageProps) => {
  // Use the CDN URL constructor if listing_code is available, otherwise fall back to the image URL
  const imageUrl = property.listing_code || property.listingCode
    ? getPropertyImageUrl(property.listing_code || property.listingCode)
    : property.image;

  return (
    <div className="relative h-48 sm:h-auto sm:w-56 flex-shrink-0">
      <img 
        src={imageUrl} 
        alt={property.title} 
        className="h-full w-full object-cover"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          // Only set to placeholder if not already using placeholder and not already tracked
          if (!isPlaceholder(target.src)) {
            target.onerror = null;
            markAsPlaceholder(target.src);
            target.src = DEFAULT_IMAGE;
          }
        }}
      />
      {property.featured && (
        <div className="absolute top-3 left-3 bg-amber-500 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center text-white gap-1 shadow-md">
          <Star size={10} className="fill-white text-white" />
          Featured
        </div>
      )}
      {property.boosted && (
        <div className="absolute top-3 right-3 bg-blue-500 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center text-white gap-1 shadow-md">
          <Rocket size={10} className="text-white" />
          Boosted
        </div>
      )}
      
      {property.hasUnreadMessages && (
        <div className="absolute bottom-3 left-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1 shadow-md">
          <MessageCircle size={12} className="text-white" />
          New Messages
        </div>
      )}
      {property.hasUpdates && (
        <div className="absolute bottom-3 right-3 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1 shadow-md">
          <Bell size={12} className="text-white" />
          Updates
        </div>
      )}
    </div>
  );
};

export default ListingImage;
